import { z } from 'zod';

/** CEC テナントへの所属状態 */
export const TenantJoinStatusSchema = z.enum([
  /** 未招待 */
  'not_invited',
  /** 招待済み・承諾待ち */
  'pending',
  /** 所属済み */
  'member',
  /** Graph 呼び出し失敗などで判定不能 */
  'unknown',
]);

export type TenantJoinStatus = z.infer<typeof TenantJoinStatusSchema>;

export const TenantJoinMeResponseSchema = z.object({
  email: z.string(),
  displayName: z.string(),
  status: TenantJoinStatusSchema,
  invitedAt: z.string().nullable(),
});

export type TenantJoinMeResponse = z.infer<typeof TenantJoinMeResponseSchema>;

export const TenantJoinRequestResponseSchema = z.object({
  email: z.string(),
  status: TenantJoinStatusSchema,
  invitedAt: z.string().nullable(),
});

export type TenantJoinRequestResponse = z.infer<
  typeof TenantJoinRequestResponseSchema
>;
